import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Table, message, Popover, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { Base } from '../../public/js/base';
import { Config } from '../../public/js/config';
import context from '../../public/js/context';
import { ContextHandler } from '../../public/js/contextHandler';
import moment from 'moment';//日期格式化导包
import './studentApplications.css';

import { partnerCheckLogin } from '../newMain/partnerMain';

const StudentApplications = (props) => {
    const history = useHistory();
    const { jobId } = useParams();

    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [jobPostModel, setJobPostModel] = useState({});

    useEffect(() => {
        if (!Config.partnerInfo?.partnerId) {
            partnerCheckLogin();
        }
        searchJobPost(jobId);
        searchApplList(pageSize, current);
    }, []);

    const searchJobPost = (jobId) => {
        Base.callBackApi("partnerHome/searchJobPost", {'jobId': jobId}).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setJobPostModel(model);
            } else {
                message.error(data.msg)
            }
        })
    }

    const searchApplList = (pageSizeNew, currentPageNew) => {
        let model = {};
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.jobApplStatusList = ['PEND_IP_RECEIPT', 'IP_PROCESSING', 'REQUEST_DOCUMENT', 'DOCUMENT_ATTACHED', 'DOCUMENT_SUBMITTED', 'OFFER', 'DECLINED', 'OFFER_DECLINED', 'IN_PROGRESS', 'WITHDRAWN', 'SPECIAL_ARRANGEMENT'];
        model.partnerId = Config.partnerInfo?.partnerId;
        model.jobId = jobId;
        Base.callBackApi("partnerHome/searchApplList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setTables(data?.object?.list ?? []);
                setTablesCount(data?.object?.total ?? 0);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { });
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        searchApplList(pageSizeNew, currentNew);
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        searchApplList(pageSizeNew, 1);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        // if (sorter.field) {
        //     if (sorter.order === "ascend") {
        //         orderBy = tableColumns[sorter.field];
        //     } else if (sorter.order === "descend") {
        //         orderBy = tableColumns[sorter.field] + " DESC";
        //     }
        // }
        // if (!!sorter.field || !!searchModel.orderBy) {
        //     if (orderBy !== searchModel.orderBy) {
        //         searchModel.orderBy = orderBy;
        //         search(pageSize, 1, "N", true);
        //     }
        // }
    }

    const jumpAppl = (record) => {
        history.push("/partner/partnerReviewStudentApplication/" + record.jobApplId);
    }

    const jump = (path) => {
        history.push(path);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Job ID',
            dataIndex: 'jobId',
            className: 'tableWidth6',
            render: text => text ? '#' + text : '',
        },
        {
            title: 'Job Title',
            dataIndex: 'jobTitle',
            className: 'tableWidth10',
        },
        {
            title: 'Job Post Status',
            dataIndex: 'jobPostStatus',
            className: 'tableWidth8',
            render: (text) => ContextHandler.getMapValue('jobPostStatusMap', text)
        },
        {
            title: 'THEi Programme',
            dataIndex: 'progTitle',
            className: 'tableWidth13',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableProgramme'>{text}</div>
                </Popover>
            ),
        },
        {
            title: 'Application ID',
            dataIndex: 'jobApplId',
            className: 'tableWidth10',
            render: text => text ? '#' + text : '',
        },
        {
            title: 'Student ID',
            dataIndex: 'studentAcctId',
            className: 'tableWidth10',
        },
        {
            title: 'Student',
            className: 'tableWidth10',
            render: (text, record) => <div>{record.firstName + " " + record.lastName}</div>
        },
        {
            title: 'Application Date',
            dataIndex: 'applyDate',
            className: 'tableWidth10',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Status',
            dataIndex: 'jobApplStatus',
            className: 'tableWidth14',
            render: text => (
                <div className='tableStatusBox'>
                    {context.partnerJobApplStatusMap.map(item => item.value === text && <div className={'tableStatus ' + item.value}>
                        {item.label}
                    </div>)}
                </div>
            ),
        },
        {
            title: 'Attention Needed',
            dataIndex: 'attentionNeeded',
            className: 'tableWidth10',
            render: (text) => <div className='newInfoStyle'>{ContextHandler.getMapValue('attentionNeededMap', text)}</div>
        },
        {
            title: 'Action',
            dataIndex: '',
            fixed: 'right',
            width: 80,
            render: (text, value) => (
                <div className='tableAction'>
                    <div className='tableActionExport' onClick={() => jumpAppl(value)}></div>
                </div>
            )
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className='websiteTemplate studentApplications'>
            <div className='websiteSysButtonRow'>
                <div className="detailTitle">
                    Student Applications
                </div>
                <div className="websiteSysButtonBox">
                    <Button className="websiteSysButton" style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} type="primary" icon={<EyeOutlined style={{ fontSize: "18px" }} />}
                        onClick={() => jump('/partner/partnerJobPostingDetail/' + jobPostModel?.jobId + '/view')}>Job Posting Detail</Button>
                    {/* <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} onClick={() => jump('/partner/partnerJobPostingDetail/' + jobPostModel?.jobId + '/view')}>Job Posting Detail</div> */}
                </div>
            </div>
            <div className='topCard' style={{ borderLeft: '8px solid #FFC168', borderRight: '8px solid #FFC168' }}>
                <div className='topCardLeft'>
                    <div className='cardProgrammeRow'>
                        <div className='cardProgrammeBox' title={jobPostModel?.progTitle}>
                            <div className='cardProgrammeText'>{jobPostModel?.progTitle}</div>
                        </div>
                        <div>
                            <div className='cardProgrammeText'>Job ID #{jobPostModel?.jobId}</div>
                        </div>
                        {
                            jobPostModel?.specialArrange === 'Y' &&
                            <div className='cardProgrammeBox specialBox'>
                                <div className='cardProgrammeText'>Special Arrangement</div>
                            </div>
                        }
                    </div>
                    <div className='cardTitleBox'>
                        <div className='cardTitle' title={jobPostModel?.jobTitle}>{jobPostModel?.jobTitle}</div>
                    </div>
                </div>
                <div className='topCardRight'>
                    <div className='flexBox'>
                        <div className='label'>
                            Expected Commence Date
                        </div>
                        <div className='value'>
                            {jobPostModel?.expCommenceDate ? moment(new Date(jobPostModel?.expCommenceDate)).format(Config.dateFormatEn) : ''}
                        </div>
                    </div>
                    <div className='flexBox'>
                        <div className='label'>
                            Expected End Date
                        </div>
                        <div className='value'>
                            {jobPostModel?.expEndDate ? moment(new Date(jobPostModel?.expEndDate)).format(Config.dateFormatEn) : ''}
                        </div>
                    </div>
                    <div className='flexBox'>
                        <div className='label'>
                            Application Deadline
                        </div>
                        <div className='value'>
                            {jobPostModel?.lastApplyDate ? moment(new Date(jobPostModel?.lastApplyDate)).format(Config.dateFormatEn) : ''}
                        </div>
                    </div>
                    <div className='flexBox'>
                        <div className='label'>
                            Job Post Approved Date
                        </div>
                        <div className='value'>
                            {jobPostModel.eventDate ? moment(new Date(jobPostModel.eventDate)).format(Config.dateFormatEn) : ''}
                        </div>
                    </div>
                    <div className='flexBox'>
                        <div className='label'>
                            Employment Type
                        </div>
                        <div className='value'>
                            {jobPostModel?.jobTypeVal}
                        </div>
                    </div>
                    <div className='flexBox'>
                        <div className='label'>
                            Job Mode
                        </div>
                        <div className='value'>
                            {jobPostModel?.positionTypeVal}
                        </div>
                    </div>
                    <div className='flexBox'>
                        <div className='label'>
                            Number of Vacancy
                        </div>
                        <div className='value'>
                            {jobPostModel.vacancies}
                        </div>
                    </div>
                </div>
            </div>

            <div className="sysTable" id="tableOne" style={{ marginTop: 20 }}>
                <Table
                    scroll={{ x: 1350 }}
                    rowKey="jobApplId"
                    columns={columns} //列名
                    dataSource={tables} //数据
                    pagination={{  //分页
                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                        onChange: onChange,            //上页下页或者跳页方法
                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                        total: tablesCount,             //总共多少条数据
                        current: current,         //当前页
                        pageSize: pageSize,       //每页显示多少条数据
                        defaultCurrent: 1,                               //默认当前页为1
                        size: "small"
                    }}
                    onChange={handleTableChange}
                />
            </div>
        </div>
    )

}

export default StudentApplications;